import React from 'react'
import lazyLoad from '@helper/lazy-load'
import { Navigate, Outlet } from 'react-router-dom'

const router = [
    {
        path: '/app/order',
        element: lazyLoad(() => import('@pages/order/components/main')),
        loader: () => ({
            menuIndex: 3,
            key: 'order.order',
            icon: 'icon-dingdan',
            show: true
        }),
        children: [
            {
                index: true,
                element: <Navigate to="/app/order/order-list" />
            },
            {
                path: '/app/order/order-list',
                element: <Outlet />,
                loader: () => ({
                    menuIndex: 1,
                    key: 'order.orderList',
                    // icon: 'icon-dingdan',
                    activeMenu: '/app/order/order-list',
                    show: true
                }),
                children: [
                    {
                        index: true,
                        element: lazyLoad(() => import('@pages/order-list/components/main')),
                        loader: () => ({
                            // menuIndex: 1,
                            key: 'order.orderList',
                            // icon: 'icon-dingdan',
                            activeMenu: '/app/order/order-list',
                            show: false
                        })
                    },
                    {
                        path: '/app/order/order-list/:orderCode',
                        element: lazyLoad(() => import('@pages/order-detail/components/main')),
                        loader: () => ({ key: 'order.orderDetail', activeMenu: '/app/order/order-list', show: true })
                    }
                ]
            },
            {
                path: '/app/order/refund-list',
                element: <Outlet />,
                loader: () => ({
                    menuIndex: 2,
                    key: 'order.refundList',
                    // icon: 'icon-dingdan',
                    activeMenu: '/app/order/refund-list',
                    show: true
                }),
                children: [
                    {
                        index: true,
                        element: lazyLoad(() => import('@pages/order-refund-list/components/main')),
                        loader: () => ({
                            // menuIndex: 2,
                            key: 'order.refundList',
                            // icon: 'icon-dingdan',
                            activeMenu: '/app/order/refund-list',
                            show: false
                        })
                    },
                    {
                        path: '/app/order/refund-list/:refundCode',
                        element: lazyLoad(() => import('@pages/order-refund-detail/components/main')),
                        loader: () => ({ key: 'order.refundDetail', activeMenu: '/app/order/refund-list', show: true })
                    }
                ]
            }
        ]
    }
]

export default router
